"use client";

import { ReadonlyURLSearchParams } from "next/navigation";
import MobileShowAllFilters from "@/components/Search/components/MobileShowAllFilters";
import { FILTER_CATEGORIES } from "@/components/Search/constants";
import { FilterVersion } from "@/components/Search/types";
import RecentlyAddedDropdown from "./components/RecentlyAddedDropdown";
import FilterDropdown from "./components/Dropdown";
import { SyncInstantSearchRefinementsFromUrl } from "./SyncInstantSearchRefinementsFromUrl";

type DynamicSearchFiltersProps = {
  searchParams: ReadonlyURLSearchParams | URLSearchParams;
};

/**
 * Same UI as the default SearchFilters bar, for dynamic search where the URL can change without
 * a full navigation. Algolia UI state is kept in sync with facet-related query params via
 * `SyncInstantSearchRefinementsFromUrl`.
 */
export const DynamicSearchFilters = ({
  searchParams,
}: DynamicSearchFiltersProps) => (
  <>
    <SyncInstantSearchRefinementsFromUrl searchParams={searchParams} />
    <div>
      <div className="container gap-4 p-0 lg:max-w-[1350px]">
        <div className="flex overflow-x-auto gap-4 scrollbar-thin relative w-full">
          <MobileShowAllFilters
            filterVersion={FilterVersion.HorizontalFilter}
          />
          {FILTER_CATEGORIES.map((facet) => (
            <FilterDropdown key={facet} filterCategory={facet} />
          ))}
          <RecentlyAddedDropdown />
        </div>
      </div>
    </div>
  </>
);

export default DynamicSearchFilters;
